import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import SimpleButton from "../../Buttons/SimpleButton.js";

import SliderImageOne from "../../Global/images/sliderImage1.png";
import SliderImageTwo from "../../Global/images/sliderImage2.png";
import SliderImageThree from "../../Global/images/sliderImage3.png";
import FolderIllustration from "../../Global/images/Item_02.png";
import HandPaperIllustration from "../../Global/images/Item_01.png";
import FileIllustration from "../../Global/images/file-illustration.png";

const StyledHeaderHomepage = styled(NanoFlex)`
  border-radius: 10px;
  height: 620px;

  .sliderStack {
    position: relative;
    display: block;
    width: 100%;

    .slide {
      flex-shrink: 0;
      top: 0;
      padding: 32px 100px 32px 200px;
      width: 100%;
      min-width: 100%;
      height: 100%;
      gap: 32px;
      position: absolute;
      border-radius: 10px;
      transition: transform 400ms;
      transform: scale(1);
      overflow: hidden;
      cursor: pointer;

      &.swap {
        animation: swapCards 1200ms forwards;
      }

      &:hover {
        animation-play-state: paused;
      }

      .sliderTextWrapper {
        gap: 20px;

        .sliderTitle {
          color: ${(props) => props.theme.color.primaryColors.fontColor};
          font-weight: 600;
        }

        .sliderTitleMobile {
          display: none;
        }

        .sliderSubTitle {
          color: ${(props) => props.theme.color.primaryColors.fontColor};
        }

        .sliderSubTitleMobile {
          display: none;
        }

        .sliderBtnWrapper {
          height: auto;
          width: auto;
          margin-top: 20px;
        }
      }
      .sliderImageWrapper {
        padding: 0px 0 0 0;
        width: 40%;
        max-height: 556px;

        .imageRelativeWrapper {
          position: relative;
          width: fit-content;

          .heroImage {
            height: 100%;
            width: auto;
            border-radius: 10px;
          }

          .floatingIconWrapper {
            position: absolute;
            width: auto;
            height: auto;

            .floatingIcon {
              width: auto;
            }
          }
        }
      }

      &.slide1 {
        --m: 42px;
        background: ${(props) => props.theme.color.primaryColors.darkPurple};
        --y: calc(0 + 16px);
        transform: translate(0, var(--y));
        height: 100%;

        .imageRelativeWrapper {
          .floatingIconWrapper {
            right: 310px;
            top: -40px;

            .floatingIcon {
              height: 205px;
              transform: rotate(45deg);
            }
          }
        }

        .sliderTextWrapper {
          .sliderTitle {
            color: ${(props) => props.theme.color.primaryColors.white};
          }

          .sliderSubTitle {
            color: ${(props) => props.theme.color.primaryColors.white};
          }
        }
      }

      &.slide3 {
        --m: 16px;
        --y: calc(0 + 16px);
        background: ${(props) => props.theme.color.primaryColors.lighterYellow};
        transform: translate(0, var(--y));
        height: 100%;

        .imageRelativeWrapper {
          .floatingIconWrapper {
            right: 340px;
            bottom: 0;

            .floatingIcon {
              left: -182px;
              bottom: 0;
              height: 250px;
              width: auto;
            }
          }
        }
      }

      &.slide2 {
        --m: 32px;
        --y: calc(0 + -16px);
        background: ${(props) => props.theme.color.primaryColors.mediumPurple};
        height: 100%;
        margin-top: 0px;
        transform: translate(0, var(--y));

        .imageRelativeWrapper {
          .floatingIconWrapper {
            right: 158px;
            top: -35px;

            .floatingIcon {
              height: 170px;
              width: auto;
            }
          }
        }
      }
    }
  }

  .headerSlider {
    margin: 0 auto;
    position: relative;
    padding: 0;
    max-width: 100%;
  }

  .sliderDotsContainer {
    position: absolute;
    width: auto;
    height: 100%;
    position: absolute;
    text-align: center;
    z-index: 10;
    left: 100px;
    gap: 40px;
    flex-shrink: 0;
    top: 0;

    .sliderDot {
      width: 11px;
      min-width: 11px;
      min-height: 11px;
      height: 11px;
      margin: 0;
      margin: 5px;
      padding: 0;
      position: relative;
      border-radius: 100%;
      background-color: ${(props) => props.theme.color.primaryColors.white};
      cursor: pointer;

      &.active {
        background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
      }

      &:first-child {
        &.active {
          background-color: ${(props) => props.theme.color.primaryColors.lighterYellow};
        }
      }
    }
  }

  @keyframes sliding {
    0% {
      bottom: 0;
    }

    25% {
      bottom: 0;
    }

    50% {
      bottom: 100%;
    }

    75% {
      bottom: 100%;
    }

    90% {
      bottom: 200%;
    }

    100% {
      bottom: 200%;
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    height: 400px;

    .sliderStack {
      .slide {
        padding: 15px 50px 15px 108px;

        &.slide1 {
          .imageRelativeWrapper {
            .floatingIconWrapper {
              right: 199px;
              top: -23px;

              .floatingIcon {
                height: 125px;
                transform: rotate(45deg);
              }
            }
          }
        }
        &.slide3 {
          .imageRelativeWrapper {
            .floatingIconWrapper {
              right: 245px;

              .floatingIcon {
                height: 140px;
              }
            }
          }
        }
        &.slide2 {
          .imageRelativeWrapper {
            .floatingIconWrapper {
              top: -11px;
              right: 116px;

              .floatingIcon {
                height: 111px;
              }
            }
          }
        }
      }
    }

    .sliderDotsContainer {
      left: 50px;
      gap: 32px;

      .sliderDot {
        width: 8px;
        height: 8px;
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    height: 400px;

    .sliderStack {
      .slide {
        padding: 15px 30px 15px 100px;

        .sliderTextWrapper {
          gap: 16px;
        }

        .sliderImageWrapper {
          max-height: 550px;
          width: fit-content;
          align-items: flex-start;
        }

        &.slide1 {
        }
        &.slide3 {
          .sliderTextWrapper {
            padding-right: 59px;
          }

          .imageRelativeWrapper {
            .floatingIconWrapper {
              right: 220px;
              .floatingIcon {
              }
            }
          }
        }
        &.slide2 {
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    height: 361px;
    border-radius: 5px;

    .sliderStack {
      .slide {
        gap: 16px;
        padding: 15px 20px 15px 80px;

        .sliderImageWrapper {
          height: 300px;
        }

        .sliderTextWrapper {
          height: auto;
          .sliderBtnWrapper {
            margin-top: 0;
          }
        }

        &.slide1 {
          .imageRelativeWrapper {
            .floatingIconWrapper {
              right: 170px;
              .floatingIcon {
                height: 94px;
              }
            }
          }
        }

        &.slide3 {
          .imageRelativeWrapper {
            .floatingIconWrapper {
              right: 184px;
              .floatingIcon {
                height: 110px;
              }
            }
          }
        }

        &.slide2 {
          .imageRelativeWrapper {
            .floatingIconWrapper {
              top: -28px;
              right: 92px;
              .floatingIcon {
                height: 94px;
              }
            }
          }
        }
      }
    }

    .sliderDotsContainer {
      left: 20px;
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    height: 568px;

    .sliderStack {
      .slide {
        flex-direction: column-reverse;
        align-items: flex-start;
        gap: 8px;
        padding: 30px 20px 54px 20px;

        .sliderImageWrapper {
          height: 280px;
          align-items: center;
          width: 100%;
        }

        .sliderTextWrapper {
          align-items: center;

          .sliderTitle,
          .sliderSubTitle {
            text-align: center;
          }

          .sliderBtnWrapper {
            margin-top: 0;
            width: 100%;

            .button {
              width: 100%;

              button {
                width: 100%;
                justify-content: center;
              }
            }
          }
        }

        &.slide1 {
          .sliderTextWrapper {
            .sliderSubTitle {
              display: none;
            }

            .sliderTitle {
              display: none;
            }

            .sliderTitleMobile {
              display: flex;
              color: ${(props) => props.theme.color.primaryColors.white};
              text-align: center;
            }
            .sliderSubTitleMobile {
              display: flex;
              color: ${(props) => props.theme.color.primaryColors.white};
              text-align: center;
            }
          }

          .sliderImageWrapper {
            .imageRelativeWrapper {
              .floatingIconWrapper {
                right: 156px;
              }
            }
          }
        }

        &.slide3 {
          .sliderTextWrapper {
            padding-right: 0;
          }

          .sliderImageWrapper {
            .imageRelativeWrapper {
              .floatingIconWrapper {
                right: 165px;

                .floatingIcon {
                  margin-top: 74px;
                }
              }
            }
          }
        }
      }
    }

    .sliderDotsContainer {
      bottom: 0;
      top: 250px;
      width: 8px;
      transform: rotate(-90deg);
      width: 8px;
      left: calc(50% - 8px);
    }

    @keyframes sliding {
      0% {
        left: 0;
        bottom: 0;
      }

      25% {
        left: 0;
        bottom: 0;
      }

      50% {
        left: -100%;
        bottom: 0;
      }

      75% {
        left: -100%;
        bottom: 0;
      }

      90% {
        bottom: 0;
        left: -200%;
      }

      100% {
        bottom: 0;
        left: -200%;
      }
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    height: 556px;
    .sliderStack {
      .slide {
        padding: 30px 16px 30px 16px;

        &.slide3 {
          .sliderTextWrapper {
            padding-right: 0;
          }

          .sliderImageWrapper {
            .imageRelativeWrapper {
              .floatingIconWrapper {
                right: 125px;

                .floatingIcon {
                  margin-top: 74px;
                  height: 105px;
                }
              }
            }
          }
        }
      }
    }

    .sliderDotsContainer {
      top: 254px;
    }
  }

  @keyframes swapCards {
    0% {
      z-index: 5;
    }

    50% {
      z-index: 5;
      transform: translateX(calc(100% + 50px));
      box-shadow: ${(props) => props.theme.boxShaddow};
    }

    60% {
      z-index: -1;
      transform: translateX(calc(100% + 50px)) rotate(1.5deg);
    }

    80% {
      z-index: -1;
      box-shadow: ${(props) => props.theme.boxShaddow};
    }

    100% {
      transform: translate(calc(100% + 50px), calc(var(--y) - 15px)) rotate(1.5deg);
      z-index: -1;
      box-shadow: none;
    }
  }
`;

export default class HeaderHomepage extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      sliderIndex: 0,
    };

    this.sliderInterval = null;
  }

  componentDidMount() {
    super.componentDidMount();

    this.sliderInterval = setInterval(this.loopSlider, 4000);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    clearInterval(this.sliderInterval);
  }

  loopSlider = () => {
    let newSliderIndex = this.state.sliderIndex + 1;

    if (newSliderIndex > 2) newSliderIndex = 0;

    this.setState({ sliderIndex: newSliderIndex });
  };

  mouseEnter = () => {
    clearInterval(this.sliderInterval);
  };

  mouseLeave = () => {
    clearInterval(this.sliderInterval);
    this.sliderInterval = setInterval(this.loopSlider, 4000);

    this.setState({
      mouseDown: false,
    });
  };

  showSlide = (slide) => {
    this.setState({ sliderIndex: slide });
    clearInterval(this.sliderInterval);
  };

  render() {
    return (
      <StyledHeaderHomepage className="headerHomepage" justifyContent="stretch" alignItems="stretch">
        <NanoFlex className="sliderStack" onMouseEnter={() => this.mouseEnter()} onMouseLeave={() => this.mouseLeave()}>
          <NanoFlex className={`slide slide3 ${this.state.sliderIndex === 0 || this.state.sliderIndex === 2 ? "swap" : ""}`}>
            <NanoFlex className="sliderTextWrapper" flexDirection="column" alignItems="flex-start">
              <Type.h2 className="sliderTitle">{this.translation.homepage.slider.headerTitleSlideTwo}</Type.h2>
              <Type.p className="sliderSubTitle">{this.translation.homepage.slider.textSlideTwo}</Type.p>
              <NanoFlex className="sliderBtnWrapper">
                <Link to="/recrutamento">
                  <SimpleButton darkPurple label={this.translation.homepage.slider.buttonSlideTwo}></SimpleButton>
                </Link>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="sliderImageWrapper" flexDirection="column" alignItems="flex-end">
              <NanoFlex className="imageRelativeWrapper" justifyContent="flex-end">
                <img className="heroImage" src={SliderImageOne} alt="" />

                <NanoFlex className="floatingIconWrapper">
                  <img className="floatingIcon" src={HandPaperIllustration} alt="Hand Illustration" />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className={`slide slide2 ${this.state.sliderIndex === 0 || this.state.sliderIndex === 1 ? "swap" : ""}`}>
            <NanoFlex className="sliderTextWrapper" flexDirection="column" alignItems="flex-start">
              <Type.h2 className="sliderTitle">{this.translation.homepage.slider.headerTitleSlideOne}</Type.h2>
              <Type.p className="sliderSubTitle">{this.translation.homepage.slider.textSlideOne}</Type.p>
              <NanoFlex className="sliderBtnWrapper">
                <Link to="/assessment">
                  <SimpleButton darkPurple label={this.translation.homepage.slider.buttonSlideOne}></SimpleButton>
                </Link>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="sliderImageWrapper" flexDirection="column" alignItems="flex-end">
              <NanoFlex className="imageRelativeWrapper" justifyContent="flex-end">
                <img className="heroImage" src={SliderImageTwo} alt="" />
                <NanoFlex className="floatingIconWrapper">
                  <img className="floatingIcon" src={FolderIllustration} alt="Folder Illustration" />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className={`slide slide1 ${this.state.sliderIndex === 1 || this.state.sliderIndex === 2 ? "swap" : ""}`}>
            <NanoFlex className="sliderTextWrapper" flexDirection="column" alignItems="flex-start">
              <Type.h2 className="sliderTitle" dangerouslySetInnerHTML={{ __html: this.translation.homepage.slider.headerTitleSlideThree }}></Type.h2>
              <Type.h2 className="sliderTitleMobile" dangerouslySetInnerHTML={{ __html: this.translation.homepage.slider.headerTitleSlideThreeMobile }}></Type.h2>
              <Type.p className="sliderSubTitle" dangerouslySetInnerHTML={{ __html: this.translation.homepage.slider.textSlideThree }}></Type.p>
              <Type.p className="sliderSubTitleMobile" dangerouslySetInnerHTML={{ __html: this.translation.homepage.slider.textSlideThreeMobile }}></Type.p>
              <NanoFlex className="sliderBtnWrapper">
                <Link to="/about-us">
                  <SimpleButton yellow label={this.translation.homepage.slider.buttonSlideThree}></SimpleButton>
                </Link>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="sliderImageWrapper" flexDirection="column" alignItems="flex-end">
              <NanoFlex className="imageRelativeWrapper" justifyContent="flex-end">
                <img className="heroImage" src={SliderImageThree} alt="" />
                <NanoFlex className="floatingIconWrapper">
                  <img className="floatingIcon" src={FileIllustration} alt="Folder Illustration" />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          {/*ONLY DISPLAYS ON WEB NEEDS CLICK TO CHANGE SLIDE*/}
          <NanoFlex className="sliderDotsContainer" flexDirection="column">
            <NanoFlex className={`sliderDot ${this.state.sliderIndex === 0 ? "active" : ""}`} onClick={() => this.showSlide(0)}></NanoFlex>
            <NanoFlex className={`sliderDot ${this.state.sliderIndex === 1 ? "active" : ""}`} onClick={() => this.showSlide(1)}></NanoFlex>
            <NanoFlex className={`sliderDot ${this.state.sliderIndex === 2 ? "active" : ""}`} onClick={() => this.showSlide(2)}></NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledHeaderHomepage>
    );
  }
}
